module.exports = __webpack_public_path__ + "img/theme2.b9f9dfdc.png";